import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Calculator, FileText, Receipt, UsersThree, Files, ChartBar, Clock, WarningCircle } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TILES = [
  { icon: FileText, title: "ITR Filing", desc: "ITR-1 to ITR-7 preparation & auto-detection", to: "/income-tax/itr" },
  { icon: UsersThree, title: "Client Manager", desc: "PAN-wise client master with IT portal credentials & JSON import", to: "/income-tax/clients" },
  { icon: Receipt, title: "TDS Returns", desc: "24Q / 26Q quarterly returns with due-date tracking", to: "/income-tax/tds" },
  { icon: Calculator, title: "Advance Tax Calculator", desc: "Quarterly advance tax estimates with interest u/s 234" },
  { icon: Files, title: "Document Vault", desc: "Form-16, 26AS, AIS files — client & year-wise organized", to: "/income-tax/documents" },
  { icon: ChartBar, title: "Tax Reports", desc: "Computation summaries, refund tracking & analytics" },
];

export default function IncomeTax() {
  const [rem, setRem] = useState(null);
  useEffect(() => {
    axios.get(`${API}/it/reminders`).then((r) => setRem(r.data)).catch(() => {});
  }, []);
  const urgent = (rem?.reminders || []).filter((r) => r.severity !== "upcoming");
  const upcoming = (rem?.reminders || []).filter((r) => r.severity === "upcoming");

  return (
    <div className="p-4 sm:p-8" data-testid="income-tax-page">
      <div className="bg-slate-900 text-white rounded-sm p-6 sm:p-8 mb-8">
        <div className="flex items-center gap-3 mb-2">
          <Calculator size={34} weight="duotone" className="text-amber-400" />
          <h1 className="text-3xl sm:text-4xl font-black tracking-tighter" style={{ fontFamily: "Chivo, sans-serif" }}>
            Income Tax Module
          </h1>
        </div>
        <p className="text-slate-300 text-sm max-w-2xl">
          LokTech Dex Pro ka naya Income Tax section — ITR filing, TDS, advance tax aur client
          management ek hi jagah. Features jald hi live honge.
        </p>
      </div>

      {/* Due-date reminders */}
      {rem && rem.reminders.length > 0 && (
        <div className="mb-8 space-y-3" data-testid="it-reminders">
          {urgent.length > 0 && (
            <div className="bg-red-50 border-2 border-red-300 rounded-sm p-4" data-testid="it-reminders-urgent">
              <div className="flex items-center gap-2 mb-2"><WarningCircle size={18} weight="fill" className="text-red-600" /><p className="text-sm font-black text-red-800 uppercase tracking-wide">Due-Date Alerts ({urgent.length})</p></div>
              <div className="space-y-1">
                {urgent.slice(0, 8).map((r, i) => (
                  <p key={i} className="text-xs text-red-800" data-testid={`it-reminder-${i}`}>
                    <b>{r.client_name}</b> ({r.pan}) — {r.label} · Due <b>{r.due_date}</b> · {r.days_left < 0 ? <b>{Math.abs(r.days_left)} days OVERDUE ⚠</b> : <b>only {r.days_left} days left</b>}
                  </p>
                ))}
              </div>
            </div>
          )}
          {upcoming.length > 0 && (
            <div className="bg-amber-50 border border-amber-300 rounded-sm p-4" data-testid="it-reminders-upcoming">
              <p className="text-xs font-black text-amber-800 uppercase tracking-wide mb-1"><Clock size={13} weight="bold" className="inline mr-1" />Upcoming ({upcoming.length})</p>
              {upcoming.slice(0, 5).map((r, i) => (
                <p key={i} className="text-xs text-amber-900"><b>{r.client_name}</b> — {r.label} · Due {r.due_date} ({r.days_left} din)</p>
              ))}
            </div>
          )}
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {TILES.map((t, i) => {
          const inner = (
            <>
              <span className={`absolute top-3 right-3 inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded-sm ${t.to ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"}`}>
                {t.to ? "Live" : (<><Clock size={11} weight="bold" /> Coming Soon</>)}
              </span>
              <t.icon size={30} weight="duotone" className="text-slate-700 mb-3" />
              <h3 className="font-bold text-slate-900 mb-1">{t.title}</h3>
              <p className="text-xs text-slate-500">{t.desc}</p>
            </>
          );
          const cls = "bg-white border border-slate-200 rounded-sm p-6 relative overflow-hidden hover:border-emerald-700 transition-colors block";
          return t.to
            ? <Link key={i} to={t.to} data-testid={`it-tile-${i}`} className={cls}>{inner}</Link>
            : <div key={i} data-testid={`it-tile-${i}`} className={cls}>{inner}</div>;
        })}
      </div>
    </div>
  );
}
